import { phoneToUrl } from '../utils';
import { PartnerData, PartnerMap, Product, ProductMap } from './models';
import { Partner } from '../api/models';

export const partners: PartnerMap<PartnerData> = {
  Asurion: {
    partnerName: Partner.Asurion,
    reactAppPartner: 'SHS-ASURION',
    websiteName: 'Home+ by Asurion',
    defaultProductCode: 'HomePlus',
    helpNumber: '(844) 529-2692',
    expertSessionsPath: '/expert-sessions',
  },
  TechCoachHome: {
    partnerName: Partner.Verizon,
    reactAppPartner: 'TCH-WEB',
    websiteName: 'Tech Coach Home',
    defaultProductCode: 'VerizonProtectHome',
    availableProductCodes: ['VerizonProtectHomeFios', 'VerizonProtectHome'],
    helpNumber: '(844) 769-1991',
    expertSessionsPath: '/expert-sessions',
  },
  Sprint: {
    partnerName: Partner.Sprint,
    reactAppPartner: 'SHS-SPRINT',
    websiteName: 'Sprint Complete MyHome',
    defaultProductCode: 'CompleteMyHome',
    helpNumber: '(866) 614-9693',
    chatUrl: 'https://myhome.techhero.live/askmyexpert/login',
    expertSessionsPath: '/tech-sessions',
  },
  Verizon: {
    partnerName: Partner.Verizon,
    reactAppPartner: 'SHS-WEB',
    websiteName: 'Smart Home Support',
    defaultProductCode: 'SmartHomeSupport',
    helpNumber: '(844) 409-1998',
    expertSessionsPath: '/expert-sessions',
  },
  Test: {
    partnerName: Partner.Test,
    reactAppPartner: 'Test',
    websiteName: 'Test',
    defaultProductCode: 'Test',
    helpNumber: '(800) 555-1999',
    expertSessionsPath: '/expert-sessions',
  },
};

export const products: ProductMap<Product> = {
  HomePlus: {
    productCode: 'HomePlus',
    productName: 'Home+',
    claimUrl:
      globals.NODE_ENV === 'production'
        ? 'https://protection.asurion.com/connectedhome/en-us/authenticate?cid=vn-rtm:homeplus'
        : 'https://rtm-breakfast-sqa.retail.npr.aws.asurion.net/connectedhome/en-us/authenticate?cid=vn-rtm:homeplus',
    chatConfig: { expertise: 'home-plus' },
  },
  CompleteMyHome: {
    productCode: 'CompleteMyHome',
    productName: 'Complete MyHome',
    claimUrl:
      globals.NODE_ENV === 'production'
        ? 'https://protection.asurion.com/connectedhome/en-us/authenticate?cid=vn-rtm:sprtmh'
        : 'https://rtm-breakfast-uat.retail.prd.aws.asurion.net/connectedhome/en-us/authenticate?cid=vn-rtm:sprtmh',
  },
  SmartHomeSupport: {
    productCode: 'SmartHomeSupport',
    productName: 'Smart Home Support',
    claimUrl: 'https://protection.asurion.com/smarthomesupport/en-us/authenticate?cid=vn-rtm:shs',
    chatConfig: { expertise: 'shs-program' },
  },
  VerizonProtectHome: {
    productCode: 'VerizonProtectHome',
    productName: 'Verizon Protect Home',
    claimUrl:
      globals.NODE_ENV === 'production'
        ? 'https://protection.asurion.com/connectedhome/en-us/authenticate?cid=vn-rtm:vzwph'
        : 'https://breakfastweb-test.use1.sqa.aws.asurion.net/connectedhome/en-us/authenticate?cid=vn-rtm:vzwph',
    chatConfig: { expertise: 'vph' },
  },
  VerizonProtectHomeFios: {
    productCode: 'VerizonProtectHomeFios',
    productName: 'Verizon Protect Home',
    claimUrl:
      globals.NODE_ENV === 'production'
        ? 'https://protection.asurion.com/connectedhome/en-us/authenticate?cid=vn-rtm:vfsph'
        : 'https://breakfastweb-test.use1.sqa.aws.asurion.net/connectedhome/en-us/authenticate?cid=vn-rtm:vfsph',
    chatConfig: { expertise: 'vph-fios' },
  },
  Test: {
    productCode: 'Test',
    productName: 'Test',
  },
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/partner/data.ts